__turbopack_context__.v({
  "className": "playfair_display_f089e044-module__noUyUG__className",
  "variable": "playfair_display_f089e044-module__noUyUG__variable",
});
